import axios from 'axios';
import { BASE_API_URL } from "../utils/api-url";

export async function getStates(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/states`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}
